// extracted by mini-css-extract-plugin
export default {"jobcriteria":"styles_jobcriteria__Mrq4E"};